import { SaleScope } from '@/types/sale';
import { useQueryParams } from '../shared/use-query-params';
import { useEffect } from 'react';

export function useSaleScope() {
  const params = useQueryParams();
  const scope = params.getQueryParamByKey('scope');

  useEffect(() => {
    if (!scope || !Object.values(SaleScope).includes(scope as SaleScope)) {
      params.setQueryParam('scope', SaleScope.Group);
    }
  }, [scope]);

  const setScope = (scope: SaleScope) => {
    params.setQueryParam('scope', scope);
  };

  const isParticipationScope = scope === SaleScope.Participation;

  return { isParticipationScope, setScope, scope };
}
